// 通用缩放处理函数
function handleZoom($image, zoomIn) {
    if (zoomIn) {
        $image.css({
            'transform': 'scale(2)',
            'cursor': 'crosshair' // 放大状态的鼠标样式
        });
        $image.addClass('zoomed');
    } else {
        $image.css({
            'transform': 'scale(1)',
            'cursor': 'zoom-in' // 默认缩小状态的鼠标样式
        });
        $image.removeClass('zoomed');
    }
}

// PC端鼠标移动事件
$('.modal-dialog_image_zoom .modal-dialog_image').mousemove(function(e) {
    var $this = $(this);
    var $image = $this.find('.thumbnail_img_h');
    var thumbnailOffset = $this.offset();
    var offsetX = e.pageX - thumbnailOffset.left;
    var offsetY = e.pageY - thumbnailOffset.top;
    var thumbnailWidth = $this.outerWidth();
    var thumbnailHeight = $this.outerHeight();

    var imageX = (offsetX / thumbnailWidth) * 100;
    var imageY = (offsetY / thumbnailHeight) * 100;

    $image.css({
        'transform-origin': imageX + '% ' + imageY + '%',
    });
});

// PC端点击事件
$('.modal-dialog_image_zoom .modal-dialog_image').click(function() {
    var $this = $(this);
    var $image = $this.find('.thumbnail_img_h');
    handleZoom($image, !$image.hasClass('zoomed'));
});

// PC端鼠标移出事件
$('.modal-dialog_image_zoom .modal-dialog_image').mouseout(function() {
    var $this = $(this);
    var $image = $this.find('.thumbnail_img_h');
    handleZoom($image, false);
});

